<div class="home-page">
  <div class="home-content">
    <div class="content-wrapper">
      <section class="dashboard-section">
        <h2 class="section-title">Your Translation Dashboard</h2>
        <div class="dashboard-cards-grid">
          @for (card of dashboardCards; track card.title) {
            <app-dashboard-card
              [title]="card.title"
              [description]="getCardDescription(card)"
              [buttonText]="card.buttonText"
              [icon]="card.icon"
              [showNotificationDot]="cardNotificationDots()[card.title] || false"
              (cardClick)="navigateTo(card.route)"
            >
            </app-dashboard-card>
          }
        </div>
      </section>
      @if (exploreCards.length > 0) {
        <section class="explore-section">
          <h2 class="section-title">Explore Others</h2>
          <p class="section-subtitle">Discover AI-powered translation tools.</p>
          <div class="explore-cards-grid">
            @for (card of exploreCards; track card.title) {
              <app-explore-card
                [title]="card.title"
                [description]="card.description"
                [icon]="card.icon"
                [link]="card.link"
              >
              </app-explore-card>
            }
          </div>
        </section>
      }
    </div>
  </div>
</div>
